import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import draggable from 'vuedraggable';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { getPictureByKey } from '@/views/custom-layout/api';
import { isEmpty } from '@/utils';
export default {
  name: 'scan_and_category_config',
  components: {
    uploadFile: uploadFile,
    draggable: draggable,
    pictureLibrary: pictureLibrary
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    info: Object,
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      showPictureLibrary: false,
      pictureList: [],
      depot: {},
      updateIndex: 0
    };
  },
  methods: {
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureList = picture[1] || [];
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.value.config.value[this.updateIndex]['imageurl'] = path;
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(index) {
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.updateIndex = index;
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload(index) {
      this.$refs.uploadBanner[index].uploadBanner();
    },
    onDelete: function onDelete(item) {
      if (!item.imageurl) {
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        item.imageurl = '';
      });
    },
    getType: function getType(type) {
      return {
        scan: '扫码绑卡',
        category: '福利中心'
      }[type];
    },
    emitUploadFile: function emitUploadFile(res, item, prop) {
      var _this$$refs$item$type;
      item[prop] = "".concat(this.$ossurl).concat(res);
      (_this$$refs$item$type = this.$refs[item.type][0]) === null || _this$$refs$item$type === void 0 ? void 0 : _this$$refs$item$type.clearValidate();
    }
  },
  created: function created() {
    var _this2 = this;
    if (isEmpty(this.value.config)) {
      var config = ['category', 'scan'].map(function (type) {
        return {
          type: type,
          imageurl: _this2.value.default_value["".concat(type, "_imageurl")]
        };
      });
      this.$set(this.value.config, 'value', config);
    }
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index //兼容新老组件 默认预置2
    }));
    this.getPicture();
  }
};